import { resource } from '@/plugins/http'

export default resource('/v1/professional/settings/profiles/me')



// WEBPACK FOOTER //
// ./src/store/resources/professional.js